import React, { useState, useEffect } from 'react';
import AuthLayout from '../../layout/authLayout';
import {
  Typography,
  Grid,
  Button,
  FormControl,
  FormHelperText,
} from '@mui/material';
import InputBox from '../../components/inputBox';
import ApiClient from '../../config/api';
import EastIcon from '@mui/icons-material/East';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { convertPersianToEnglish } from '../../components/converter';
import { setPhoneNumber, setRoute } from '../../store/auth';

const Register = () => {
  const api = ApiClient();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [lastName, setLastName] = useState('');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const phoneNumber = useSelector((st) => st?.auth?.phoneNumber);

  useEffect(() => {
    if (!phoneNumber) {
      dispatch(setRoute('/'));
      navigate('/');
    }
  }, []);

  const handleChangeName = (newValue) => {
    setName(newValue);
  };
  const handleChangeLastName = (newValue) => {
    setLastName(newValue);
  };
  const handleChangePassword = (newValue) => {
    setPassword(newValue);
  };
  const handleChangeConfirmPassword = (newValue) => {
    setConfirmPassword(newValue);
  };
  const handleChangePhone = (newValue) => {
    if (newValue?.length <= 11) dispatch(setPhoneNumber(newValue));
  };

  const onSubmit = async () => {
    if (name && lastName && phoneNumber && password && confirmPassword) {
      if (password == confirmPassword) {
        try {
          setIsLoading(true);
          setError('');
          const value = convertPersianToEnglish(phoneNumber);
          const response = await api.post(`/api/app/v1/auth/register`, {
            first_name: name,
            last_name: lastName,
            mobile: value,
            password: password,
            password_confirm: confirmPassword,
            channel: 'shipito',
            app_name: 'shipito',
          });
          navigate(
            `/otp?type=register&tempToken=${response?.data?.temp_token}`
          );
          setIsLoading(false);
        } catch (error) {
          if (
            error.response &&
            error.response.data &&
            error.response.data.errors
          ) {
            setError(error.response.data.errors[0]);
          }
        }
      } else {
        setError('کلمه عبور و تکرار آن یکسان نیست');
      }
      setIsLoading(false);
    } else {
      setError('لطفا اطلاعات را به درستی وارد نمايید');
      setIsLoading(false);
    }
  };

  return (
    <AuthLayout>
      <EastIcon
        sx={{ marginTop: '20px', paddingRight: '20px', paddingLeft: '20px' }}
        className={'clickable'}
        onClick={() => {
          navigate('/');
        }}
      />
      <Typography
        paddingRight={'20px'}
        paddingLeft={'20px'}
        fontSize={24}
        fontWeight={600}
        marginTop={'24px'}
      >
        ثبت نام
      </Typography>
      <Typography
        paddingRight={'20px'}
        paddingLeft={'20px'}
        color={'primary.gray'}
        fontSize={16}
        fontWeight={600}
        marginTop={'12px'}
        marginBottom={'32px'}
      >
        لطفا، اطلاعات زیر را تکمیل نمایید.
      </Typography>
      <Grid
        container
        paddingRight={'20px'}
        paddingLeft={'20px'}
        flexDirection={'column'}
      >
        <Grid item>
          <InputBox
            label="نام"
            value={name}
            setValue={handleChangeName}
            onSubmit={onSubmit}
            isLoading={isLoading}
            maxLength={11}
            type="text"
            icon={null}
          />
        </Grid>
        <Grid item>
          <InputBox
            label="نام خانوادگی"
            value={lastName}
            setValue={handleChangeLastName}
            onSubmit={onSubmit}
            isLoading={isLoading}
            maxLength={11}
            type="text"
            icon={null}
          />
        </Grid>
        <Grid item>
          <InputBox
            label="شماره موبایل"
            value={phoneNumber}
            onSubmit={onSubmit}
            setValue={handleChangePhone}
            isLoading={true}
            maxLength={11}
            type="number"
            icon={null}
          />
        </Grid>
        <Grid item>
          <InputBox
            label="کلمه عبور"
            value={password}
            setValue={handleChangePassword}
            onSubmit={onSubmit}
            isLoading={isLoading}
            type="password"
            icon={null}
          />
        </Grid>
        <Grid item>
          <InputBox
            label="تکرار کلمه عبور"
            value={confirmPassword}
            setValue={handleChangeConfirmPassword}
            onSubmit={onSubmit}
            isLoading={isLoading}
            type="password"
            icon={null}
          />
        </Grid>
        <Grid item>
          <FormControl
            size="small"
            variant="standard"
            fullWidth
            error={Boolean(error)}
          >
            {error && <FormHelperText>{error}</FormHelperText>}
          </FormControl>
          <Button
            onClick={onSubmit}
            disabled={isLoading}
            sx={{
              marginTop: '24px',
              width: '100%',
              height: '57px',
              borderRadius: '8px',
              color: 'primary.contrastText',
              fontFamily: 'iran-sans-light',
              fontSize: '16px',
              fontWeight: '600',
              marginTop: '0px',
            }}
            size="large"
            variant="contained"
          >
            تایید و ادامه
          </Button>
        </Grid>
      </Grid>
    </AuthLayout>
  );
};

export default Register;
